import { defineSemanticTokens } from '@chakra-ui/react';

/**
 * Semantic colors (often references + `colorPalette`).
 * @see https://chakra-ui.com/docs/theming/overview#theme
 */
export const semanticTokens = defineSemanticTokens({
  colors: {
    brand: {
      solid: { value: '{colors.brand.500}' },
      contrast: { value: '{colors.body}' },
      fg: { value: '{colors.brand.800}' },
      muted: { value: '{colors.brand.100}' },
      subtle: { value: '{colors.brand.200}' },
      emphasized: { value: '{colors.brand.300}' },
      focusRing: { value: '{colors.brand.500}' },
    },
  },
});
